import { UseEditableWidgetBackend } from '@procureai/ui-modules-mui';

import { createEditableWidgetGraphqlBackendHook } from '@/shared/hooks/useEditableWidgetGraphqlBackend/useEditableWidgetGraphqlBackend';
import { defaultLanguage } from '~/common/constants';
import { isSourcingCaseEditable } from '~/common/guards/sourcingCase.guards';
import { useModuleContext } from '~/components/ModuleContextProvider';
import {
  supplierContactSchemaWithName,
  SupplierContactWithName,
} from '~/routes/IntakeDetail/components/SupplierContactForm/SupplierContactForm.schema';

import { SOURCING_CASE_CONTACT_UPDATE_MUTATION } from './SourcingCaseContactWidget.mutation.gql';
import { SOURCING_CASE_CONTACT_QUERY } from './SourcingCaseContactWidget.query.gql';

const useSourcingCaseContactWidgetBackendInternal = createEditableWidgetGraphqlBackendHook({
  schema: supplierContactSchemaWithName,
  query: SOURCING_CASE_CONTACT_QUERY,
  mutation: SOURCING_CASE_CONTACT_UPDATE_MUTATION,
});

export const useSourcingCaseContactWidgetBackend: UseEditableWidgetBackend<SupplierContactWithName> = ({ i18n }) => {
  const { entityId } = useModuleContext();
  const variables = { id: entityId };

  return useSourcingCaseContactWidgetBackendInternal({
    i18n,
    variables,
    skip: !entityId,
    toFormData: (data) => {
      const sourcingCase = data.tesseract.sourcingCase;
      if (!sourcingCase) {
        throw new Error('No sourcing case found');
      }
      const supplier = sourcingCase.supplier;
      if (!supplier) {
        throw new Error('No supplier found');
      }
      const contact = supplier.contact;
      return {
        supplier: {
          name: supplier.name ?? '',
          internalId: supplier.supplierId,
          isQuoted: false,
          location: null,
          source: null,
          contact: {
            internalId: contact.internalId,
            email: contact.email ?? '',
            firstName: contact.firstName ?? '',
            lastName: contact.lastName ?? '',
            language: contact.language ?? defaultLanguage,
          },
        },
      };
    },
    toMutationData: (formData) => {
      const contact = formData.supplier.contact;
      return {
        id: entityId,
        data: {
          contactId: contact.internalId,
          email: contact.email,
          firstName: contact.firstName,
          lastName: contact.lastName,
          language: contact.language as any,
        },
      };
    },
    toSimpleFormWidgetProps: (data, loading) => {
      return loading || !isSourcingCaseEditable(data?.tesseract.sourcingCase)
        ? { disabled: true }
        : { disabled: false };
    },
  });
};
